import React, { useState } from 'react';
import { ArrowRight, Mail, MapPin, Phone, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="dark-header">
        <Link to="/" className="dark-logo-text">NIRAIE</Link>
        <nav className="dark-nav">
          <a href="/#features" className="dark-nav-link">Features</a>
          <a href="/#pricing" className="dark-nav-link">Pricing</a>
          <a href="/#faq" className="dark-nav-link">FAQ</a>
          <Link to="/contact" className="dark-nav-link active">Contact</Link>
          <button className="btn-primary">Get Started</button>
        </nav>
        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </header>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <a href="/#features" className="mobile-menu-link" onClick={toggleMobileMenu}>Features</a>
          <a href="/#pricing" className="mobile-menu-link" onClick={toggleMobileMenu}>Pricing</a>
          <a href="/#faq" className="mobile-menu-link" onClick={toggleMobileMenu}>FAQ</a>
          <Link to="/contact" className="mobile-menu-link" onClick={toggleMobileMenu}>Contact</Link>
          <button className="btn-primary" style={{width: '100%'}}>Get Started</button>
        </div>
      )}

      {/* Contact Hero */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-subtitle">
            Have questions about our AI tax engine? We're here to help.
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-section">
        <div className="contact-container">
          {/* Contact Info */}
          <div className="contact-info">
            <h2 className="contact-info-title">Contact Information</h2>
            <p className="contact-info-text">
              Reach out to us through any of these channels. We'll respond within 24 hours.
            </p>

            <div className="contact-info-items">
              <div className="contact-info-item">
                <div className="contact-icon">
                  <Mail className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="contact-item-title">Email</h3>
                  <p className="contact-item-text">niraiethechatengine@gmail.com</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <Phone className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="contact-item-title">Phone</h3>
                  <p className="contact-item-text">+91 93859 32082</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <MapPin className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="contact-item-title">Address</h3>
                  <p className="contact-item-text">
                    97G/10/1 Teachers Colony<br />
                    5th Street West<br />
                    Tuticorin-628008
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <h2 className="contact-form-title">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="What's this about?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="form-textarea"
                  placeholder="Tell us more..."
                />
              </div>

              <button type="submit" className="btn-primary btn-full">
                Send Message
                <ArrowRight className="w-5 h-5" />
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="dark-footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">NIRAIE</div>
            <p className="footer-tagline">AI-Powered Tax Intelligence for Everyone</p>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              <li><a href="/#features">Features</a></li>
              <li><a href="/#pricing">Pricing</a></li>
              <li><a href="/#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="#">Help Center</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Niraie. All rights reserved.</p>
        </div>
      </footer>

      {/* Custom Credit Badge */}
      <div className="custom-credit">
        <span>Made with</span>
        <a href="https://sukraconsolv.com" target="_blank" rel="noopener noreferrer" className="custom-credit-link">
          SUKRA CONSOLV
        </a>
      </div>
    </div>
  );
};

export default Contact;
